import { Dispatch } from 'react-redux';
import { AuthActionCreators, IApplicationState } from "../";
import { IProduct, IBaseResponse, IProductRequest } from "../../models";
import { AxiosError } from 'axios';
import { ActionTypes } from './action-types';

export interface IProductListResponse {
    data: {
        success: boolean,
        message: string,
        results: IProduct[]
    }
}

export interface ISaveProductResponse {
    data: {
        success: boolean,
        message: string,
        results: IProduct
    }
}

export const ActionCreatorsProduct = {
    getProducts: () => (dispatch: Dispatch<IApplicationState>): Promise<IProductListResponse> => {
        var options = {
            url: __API__ + `/crm/product`
        };

        return dispatch(AuthActionCreators.apiGet(options))
            .then((response: IProductListResponse) => {
                if (response.data.success)
                    dispatch(ActionCreatorsProduct.setProductList(response.data.results));

                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },
    setProductList: (products: IProduct[]) => {
        return {
            type: ActionTypes.SET_CRM_PRODUCT_LIST,
            products
        };
    },
    updateProductOwner: (productId: number, owner: string) => (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        var options = {
            url: `${__API__}/crm/product/${productId}/owner/${owner}`,
        };

        return dispatch(AuthActionCreators.apiPut(options))
            .then((response: ISaveProductResponse) => {
                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },
    updateProductIsActive: (productId: number, isActive: boolean) => (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        var options = {
            url: `${__API__}/crm/product/${productId}/is-active/${isActive}`,
        };

        return dispatch(AuthActionCreators.apiPut(options))
            .then((response: ISaveProductResponse) => {
                if (response.data.success)
                    dispatch(ActionCreatorsProduct.setProductIsActive(productId, isActive));

                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },
    setProductIsActive: (productId: number, isActive: boolean) => {
        return {
            type: ActionTypes.SET_PRODUCT_IS_ACTIVE,
            productId,
            isActive
        };
    }
}